import Vue from "vue";
import App from "./App.vue";
import store from "./store/store";
import './plugins/element.js';
//import 'element-ui/lib/theme-chalk/index.css';

/*
//import a vue flexbox
import VueFlex from 'vue-flex';
import "vue-flex/dist/vue-flex.css";
Vue.use(VueFlex);
*/

/*a
* flexbox based grid for vue
* https://bkzl.github.io/vue-fraction-grid/
*/
import VueFractionGrid from 'vue-fraction-grid';
Vue.use(VueFractionGrid, {
  gutter: '20px',
  approach: 'desktop-first',
  breakpoints: {
    numResultSeletorBreaks: '640px',
    result2Column: '710px',
    compact: '870px',
    tablet: '870px'
  }
});

/*
* Some vue config
* */

Vue.config.productionTip = false;

/*
* AXIOS AJAX Handling
*
* */
import axios from 'axios';

//global axios settings
axios.defaults.baseURL = wpData.fm_admin_ajax_url;
//axios.defaults.baseURL = 'https://www.mypetpeed.com/wp-admin/admin-ajax.php';
axios.defaults.timeout = process.env.VUE_APP_AXIOS_TIMEOUT; //global axios timeout in ms (60000 = 1min)

//interceptors ... check global environment (.env) for value set based on dev or production environment
//Note: other modes are env.production, env.test, env.development all overwriting the .env ... also we can set up our own ...
if(process.env.VUE_APP_AXIOS_SHOW_INTERCEPTOR=='true'){
  //var myGlobalAxiosRequestInterceptor = axios.interceptors.request.use(config => {
  axios.interceptors.request.use(config => {
    console.log('Request Interceptor', config)
    //console.log('Request Interceptor2', axios.request());
    return config;
  });

  axios.interceptors.response.use(response => {
    console.log('Response Interceptor', response)
    return response;
  });
}

/*
* INIT VUE Instance
*
* */


new Vue({
  store,
  render: h => h(App)
}).$mount("#fm_app");
